import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { first, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ElectricianDTO } from '../dto/ElectricianDTO';
import { EditReviewDTO } from '../dto/EditReviewDTO';

@Injectable({
  providedIn: 'root',
})
export class ElectricianService {
  private baseUrl = environment.API_URL + '/admin/electrician';

  constructor(private http: HttpClient) {}

  saveElectrician(electricianDTO: ElectricianDTO): Observable<any> {
    const url = `${this.baseUrl}/save`;
    return this.http.post<any>(url, electricianDTO).pipe(first());
  }

  uploadImage(identifier: string, files: any[]): Observable<any> {
    const formData = new FormData();
    // formData.append('identifier', identifier);
    files.forEach((image) => {
      formData.append('files', image.file);
    });
    const url = `${this.baseUrl}/uploadprofilephoto/${identifier}`;
    return this.http.post<any>(url, formData).pipe(first());
  }

  allElectricianList() {
    const url = `${this.baseUrl}`;
    return this.http.get<any>(url).pipe(first());
  }

  getElectricianDetails(identifier: string) {
    const url = `${this.baseUrl}/${identifier}`;
    return this.http.get<any>(url).pipe(first());
  }

  delElectricianDetails(identifier: string): Observable<any> {
    const url = `${this.baseUrl}/delete/${identifier}`;
    return this.http.post<any>(url, identifier).pipe(first());
  }

  editElectrician(electricianDTO: ElectricianDTO): Observable<any> {
    const url = `${this.baseUrl}/edit`;
    return this.http.post<any>(url, electricianDTO).pipe(first());
  }

  getAllReviews(page = 0, size = 10): Observable<any> {
    const url = `${this.baseUrl}/getallreviews?page=${page}&size=${size}`;
    return this.http.get<any>(url).pipe(first());
  }

  getAllReviewsForElectrician(id: any): Observable<any> {
    const url = `${this.baseUrl}/getallreviewsforelectrician/${id}`;
    return this.http.get<any>(url).pipe(first());
  }

  editReview(editReview: EditReviewDTO): Observable<any> {
    const url = `${this.baseUrl}/editreview`;
    return this.http.post<any>(url, editReview).pipe(first());
  }

  getAllReviewsPaginated(page = 0, size = 10): Observable<any> {
    const url = `${this.baseUrl}/getallreviews?page=${page}&size=${size}`;
    return this.http.get<any>(url).pipe(first());
  }
}
